import { render, staticRenderFns } from "./baseSelectResearchCenter.vue?vue&type=template&id=a3ccbf86&scoped=true&"
import script from "./baseSelectResearchCenter.vue?vue&type=script&lang=ts&"
export * from "./baseSelectResearchCenter.vue?vue&type=script&lang=ts&"
import style0 from "./baseSelectResearchCenter.vue?vue&type=style&index=0&id=a3ccbf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ccbf86",
  null
  
)

export default component.exports